<template>
  <img :src="path" :title="title" :alt="alt" />
</template>

<script>
  import ICONS from '../icons.js';
  import config from '@/config/global.config'

  export default {
    name: 'SvgIcon',
    components: {},
    props: {
      icon: {
        type: String
      },
      title: {
        type: String,
        default: ''
      },
      alt: {
        type: String,
        default: ''
      },
    },

    computed: {
      path () {
        return config.generateUrl(ICONS[this.icon]);
      }
    }
  }
</script>
